import { InertiaLink } from '@inertiajs/inertia-react'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import route from 'ziggy-js'
import { getOpeningStatus } from '../../openingHours'
import { t } from '../Translator'


export default function OpeningWidget({dark}:{dark?:boolean}) {
    const [now, setNow] = useState(() => new Date())

    useEffect(() => {
        const interval = window.setInterval(() => setNow(new Date()), 60 * 1000)

        return () => window.clearInterval(interval)
    }, [])

    function today() {
        const status = getOpeningStatus(now)

        if (status.type === "opensToday") {
            return `${t("Dnes")} ${t("od")} ${status.time}`
        }

        if (status.type === "closesToday") {
            return `${t("Dnes")} ${t("do")} ${status.time}`
        }

        return `${t("Zítra")} ${t("od")} ${status.time}`
    }


    return (
        <InertiaLink href={route('kontakt')} className="flex items-center">
            <motion.div
                transition={{ repeat: Infinity, duration: 1.6 }}
                animate={{ opacity: 0 }}
                initial={{ opacity: 1 }}
                className={`w-4px h-4px ${dark ? " bg-white" : " bg-brown-dark"}  mr-8px rounded-full`}></motion.div>
            <div className={`${dark ? " text-white " : " text-brown-dark"} font-semibold text-14`}>{today()}</div>
        </InertiaLink>
    )
}
